import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    since: String
  }

  connect() {
    this.update()
    this.interval = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  update() {
    const since = new Date(this.sinceValue)
    const now = new Date()
    const diffMs = now - since

    const seconds = Math.floor(diffMs / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    let text
    if (days > 0) {
      text = `${days}d ${hours % 24}h ${minutes % 60}m`
    } else if (hours > 0) {
      text = `${hours}h ${minutes % 60}m ${seconds % 60}s`
    } else if (minutes > 0) {
      text = `${minutes}m ${seconds % 60}s`
    } else {
      text = `${seconds}s`
    }

    this.element.textContent = text
  }
}
